import React from 'react';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import IconButton from '@mui/material/IconButton';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { withStyles } from "tss-react/mui";
import { Subtitle2, Body2 } from 'components/Typography';
import styles from './styles';

function ItemPicker(props) {
    return (
        <ListItem button={!props.disabled} onClick={props.disabled ? null : props.onSelectionChanged} className={props.classes.listItemRoot}>
            {props.icon &&
                <ListItemIcon>
                    <div className={props.disabled ? '' : props.activeClass}>
                        {props.icon}
                    </div>
                </ListItemIcon>
            }
            {props.selected &&
                <ListItemText>
                    <Subtitle2>{props.pickerName}</Subtitle2>
                    <Body2>{props.selectedText}</Body2>
                </ListItemText>
            }
            {!props.selected &&
                <ListItemText>
                    <Subtitle2>{props.pickerName}</Subtitle2>
                    <Body2>Select</Body2>
                </ListItemText>

            }
            {!props.disabled &&
                <ListItemSecondaryAction>
                    <IconButton
                        title="Select"
                        aria-label="Select"
                        onClick={props.onSelectionChanged}
                        className={props.classes.chevron}
                        size="large">
                        <ChevronRightIcon />
                    </IconButton>
                </ListItemSecondaryAction>
            }

        </ListItem>
    );
}

export default withStyles(ItemPicker, styles);